// extracted by mini-css-extract-plugin
export default {"companyContainer":"iL-z","companyImage":"jL-z","container":"kL-z","heading":"lL-z","darkText":"mL-z","smallHeading":"nL-z","darkBackground":"oL-z","whiteBackground":"pL-z"};